import pdfOne from '../assets/pdf/1.pdf';

const pdfMap = {
  1: pdfOne,
};

export default pdfMap;
